import { requests } from '../index';
import axios from 'axios';
import URLS from "../endPoints";
let Search = {}

Search.SearchSuggestion = async (payload) => await requests.post(URLS.magUrl.searchsuggestionApi,payload) //api call


export default Search